export const UserCruiseBookingData = [
  {
    key: "1",
    id: "#CB-1245",
    cruiseimage:"assets/img/cruise/cruise-15.jpg",
    cruisename: "Super Aquamarine",
    location:"Barcelona",
    cabin:"Interior",
    members:"2 Adults, 1 Child",
    day:"4 Days, 3 Nights",
    pricing:"$11,569",
    date:"15 May 2025",
    status:"Upcoming",
    action:"upcoming",
  },
  {
    key: "2",
    id: "#CR-3215",
    cruiseimage:"assets/img/cruise/cruise-06.jpg",
    cruisename: "Adventure of the Seas",
    location:"London",
    cabin:"Balcony",
    members:"2 Adults, 2 Child",
    day:"3 Days, 2 Nights",
    pricing:"$10,745",
    date:"20 May 2025",
    status:"Upcoming",
    action:"upcoming",
  },
  
  {
    key: "3",
    id: "#CR-4581",
    cruiseimage:"assets/img/cruise/cruise-05.jpg",
    cruisename: "Coral Cruiser",
    location:"Edinburgh",
    cabin:"Oceanview",
    members:"3 Adults, 2 Child",
    day:"2 Days, 1 Night",
    pricing:"$8,160",
    date:"04 Jun 2025",
    status:"Upcoming",
    action:"upcoming",
  },
  {
    key: "4",
    id: "#CR-6545",
    cruiseimage:"assets/img/cruise/cruise-12.jpg",
    cruisename: "Celebrity Cruise",
    location:"Manchester",
    cabin:"Suite",
    members:"2 Adults, 1 Child",
    day:"5 Days, 4 Nights",
    pricing:"$14,840",
    date:"17 Jun 2025",
    status:"Pending",
    action:"pending",
  },
  {
    key: "5",
    id: "#CR-3256",
    cruiseimage:"assets/img/cruise/cruise-09.jpg",
    cruisename: "Princess Cruises",
    location:"Chelsea",
    cabin:"Concierge Class",
    members:"1 Adult, 1 Child",
    day:"3 Days, 2 Nights",
    pricing:"$10,450",
    date:"25 Jun 2025",
    status:"Upcoming",
    action:"upcoming",
  },
  {
    key: "6",
    id: "#CR-3654",
    cruiseimage:"assets/img/cruise/cruise-12.jpg",
    cruisename: "Cunard",
    location:"Las Vegas",
    cabin:"Outside room",
    members:"3 Adults, 2 Child",
    day:"4 Days, 3 Nights",
    pricing:"$12,600",
    date:"02 Jul 2025",
    status:"Cancelled",
    action:"cancelled",
  },
  {
    key: "7",
    id: "#CR-1458",
    cruiseimage:"assets/img/cruise/cruise-25.jpg",
    cruisename: "Norwegian Cruise",
    location:"Salford",
    cabin:"Solo cabins",
    members:"1 Adult, 1 Child",
    day:"2 Days, 1 Night",
    pricing:"$9,380",
    date:"12 Jul 2025",
    status:"Completed",
    action:"completed",
  },
  {
    key: "8",
    id: "#CR-6589",
    cruiseimage:"assets/img/cruise/cruise-26.jpg",
    cruisename: "Azamara",
    location:"Newyork",
    cabin:"Balcony",
    members:"2 Adults, 1 Child",
    day:"3 Days, 2 Nights",
    pricing:"$10,400",
    date:"26 Jul 2025",
    status:"Completed",
    action:"completed",
  },
  {
    key: "9",
    id: "#CR-2315",
    cruiseimage:"assets/img/cruise/cruise-27.jpg",
    cruisename: "Costa Cruise",
    location:"Cambridge",
    cabin:"Interior",
    members:"3 Adults, 2 Child",
    day:"4 Days, 3 Nights",
    pricing:"$12,810",
    date:"10 Aug 2025",
    status:"Completed",
    action:"completed",
  },
  {
    key: "10",
    id: "#CR-5414",
    cruiseimage:"assets/img/cruise/cruise-28.jpg",
    cruisename: "Oceania Cruises",
    location:"Bristol",
    cabin:"Outside room",
    members:"1 Adult, 1 Child",
    day:"5 Days, 4 Nights",
    pricing:"$15,450",
    date:"22 Aug 2025",
    status:"Completed",
    action:"completed",
  },

];
